import { render, staticRenderFns } from "./CardUpdateStatus.vue?vue&type=template&id=2c861866&scoped=true&"
import script from "./CardUpdateStatus.vue?vue&type=script&lang=js&"
export * from "./CardUpdateStatus.vue?vue&type=script&lang=js&"
import style0 from "./CardUpdateStatus.vue?vue&type=style&index=0&id=2c861866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c861866",
  null
  
)

export default component.exports